import { render, staticRenderFns } from "./OffHandle.vue?vue&type=template&id=49dd8c89&"
import script from "./OffHandle.vue?vue&type=script&lang=js&"
export * from "./OffHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports